import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = { class: "settings-card" }
const _hoisted_3 = { class: "tz-current-box" }
const _hoisted_4 = { class: "tz-current-info" }
const _hoisted_5 = { class: "tz-current-name" }
const _hoisted_6 = { class: "tz-current-offset" }
const _hoisted_7 = { class: "tz-current-clock" }
const _hoisted_8 = { class: "tz-picker" }
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "save-row" }
const _hoisted_12 = {
  key: 0,
  class: "save-success"
}
const _hoisted_13 = {
  key: 0,
  class: "save-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"card-header\" data-v-05af72b2><div class=\"card-icon\" data-v-05af72b2><svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" data-v-05af72b2><circle cx=\"12\" cy=\"12\" r=\"10\" data-v-05af72b2></circle><polyline points=\"12 6 12 12 16 14\" data-v-05af72b2></polyline></svg></div><div data-v-05af72b2><h3 class=\"card-title\" data-v-05af72b2>Fuso Horário da Obra</h3><p class=\"card-desc\" data-v-05af72b2>Referência oficial de horários da obra: notificações de rotinas, vencimentos e registros. Alteração somente manual.</p></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "field-label" }, "Fuso atual", -1)),
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.form.timezone || 'America/Sao_Paulo') + " ", 1),
            _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(_ctx.offsetOf(_ctx.form.timezone || 'America/Sao_Paulo')) + ")", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.clockPreview), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "field-label" }, "Alterar fuso", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
          class: "field-input",
          type: "text",
          placeholder: "Buscar fuso (ex: Sao_Paulo, New_York, Lisbon)..."
        }, null, 512), [
          [_vModelText, _ctx.filter]
        ]),
        _createElementVNode("select", {
          class: "field-input tz-select",
          size: "8",
          value: _ctx.form.timezone || 'America/Sao_Paulo',
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-form', { field: 'timezone', value: ($event.target as HTMLSelectElement).value })))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredZones, (tz) => {
            return (_openBlock(), _createElementBlock("option", {
              key: tz,
              value: tz
            }, _toDisplayString(tz) + " (" + _toDisplayString(_ctx.offsetOf(tz)) + ")", 9, _hoisted_10))
          }), 128))
        ], 40, _hoisted_9),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "field-hint" }, "O fuso da obra não muda sozinho — mesmo que a obra seja acessada de outros países, só é alterado aqui.", -1))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "btn-save",
          type: "button",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('save')))
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.2"
          }, [
            _createElementVNode("path", { d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" }),
            _createElementVNode("polyline", { points: "17 21 17 13 7 13 7 21" }),
            _createElementVNode("polyline", { points: "7 3 7 8 15 8" })
          ], -1),
          _createTextVNode(" Salvar ", -1)
        ]))]),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (_ctx.successText)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.successText), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (_ctx.errorText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.errorText), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}